export default __webpack_public_path__ + "static/media/tm-portal-light.d0b7cc05.png";